// src/store/authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { initialState } from '../../data/initialState.auth.data';
import { login as loginAPI } from '../../apis/authAPIs';
import { ErrorMessages } from '../../constants/error';
import { setItem, removeItem } from '../../utils/storage';
import { handlePending } from '../../constants/';
import { clearAllDataFromSessionStorage } from '../../services/common/commonDataService';
import { parseJwt } from '../../utils/common';

export const login = createAsyncThunk(
  'auth/login',
  async (body, { rejectWithValue }) => {
    try {
      const response = await loginAPI(body);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const handleLoginRejection = (state) => {
  state.loading = false;
  state.errorMsg = ErrorMessages.loginFailed;
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAccountDetail: (state, action) => {
      state.accountDetail = action.payload;
    },
    setUser: (state, action) => {
      state.user[action.payload.name] = action.payload.value;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.errorMsg = ErrorMessages.loginFailed;
    },
    logout: (state) => {
      state.accountDetail = null;
      state.user = null;
      state.isValid = false;
      state.isAuthenticated = false;
      removeItem('token');
      removeItem('refreshToken');
      clearAllDataFromSessionStorage();
    },
    setLoader: (state, action) => {
      state.loading = action.payload;
    },
    setAccessToken: (state, action) => {
      state.isAuthenticated = true;
      setItem('token', action.payload);
      state.loading = false;
      window.location.assign('/home');
      state.userData = JSON.parse(parseJwt(action.payload));
    },
    setTokenForUserRole: (state, action) => {
      state.accTokenUserRole = action.payload;
    },
    setToAuthorizationData: (state, action) => {
      state.authorizationData = action?.payload || initialState.authorizationData;
    },
    setToHideSidebar: (state, action) => {
      state.hideSidebar = action?.payload || initialState.hideSidebar;
    },
    setFallBackRefreshToken: (state, action) => {
      state.refreshTokenCount = action?.payload ? state.refreshTokenCount + 1 : 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, handlePending)
      .addCase(login.fulfilled, (state, action) => {
        state.errorMsg = '';
        state.error = false;
        state.loading = false;
        setItem('token', action.payload.jwToken);
        setItem('refreshToken', action.payload.refreshToken);
        window.location.assign('/customer');
      })
      .addCase(login.rejected, handleLoginRejection);
  },
});

export const {
  setAccountDetail,
  setUser,
  logout,
  setError,
  setLoader,
  setAccessToken,
  setTokenForUserRole,
  setToAuthorizationData,
  setToHideSidebar,
  setFallBackRefreshToken,
} = authSlice.actions;
export default authSlice.reducer;
